import React from 'react';
import {LogoBig} from "../../icons/icons";
import CustomButton from "../UI/customButton/customButton";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import CustomLink from "../UI/customLink/customLink";

const HeaderBeforeLogin = () => {
  const {t} = useTranslation()
  return (
    <div className={"grid grid-cols-2 md:grid-cols-3 items-center my-container-small py-5 justify-between"}>
      <LogoBig/>
      <div className={" gap-7 justify-center hidden md:flex"}>
        <div className={"max-w-40 text-gray-500 text-lg"}>
          <Link t={"/"} >
            {t("mainPage")}
          </Link>
        </div>
        <div className={"max-w-40 text-gray-500 text-lg"}>
          <Link t={"/"} >
            {t("blog")}
          </Link>
        </div>
        <div className={"max-w-40 text-gray-500 text-lg"}>
          <Link t={"/"} >
            {t("contact")}
          </Link>
        </div>
        <div className={"max-w-40 text-gray-500 text-lg"}>
          <Link t={"/"} >
            {t("about")}
          </Link>
        </div>
      </div>
      <div className={"flex justify-end"}>
        <div className={"max-w-72 md:max-w-60"}>
          <CustomLink link={"/crew/auth/login"}  title={t("loginAndRegister")}/>
        </div>
      </div>
    </div>
  );
};

export default HeaderBeforeLogin;
